<template>
  <div v-if='!asyncLoading' class="credit-card-details-form">
    <card-number-field/>
    <div class="row">
      <expiration-field class="expiration"/>
      <div class="spacer"></div>
      <cvv-field/>
    </div>
    <social-id/>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import CardNumberField from '../../../subscription/components/credit-card-fields/CardNumber.vue';
import ExpirationField from '../../../subscription/components/credit-card-fields/Expiration.vue';
import CvvField from '../../../subscription/components/credit-card-fields/CVV.vue';
import SocialId from '../../../subscription/components/credit-card-fields/SocialId.vue';

export default {
  name: 'CreditCardDetailsForm',
  components: {
    CardNumberField,
    ExpirationField,
    CvvField,
    SocialId,
  },
  data() {
    return {
      asyncLoading: true,
    };
  },
  async created() {
    await this.init();
    this.asyncLoading = false;
  },
  methods: {
    ...mapActions('subscription', ['init']),
  },
};
</script>

<style scoped lang="scss">
  .row {
    display: flex;
    justify-content: space-between;
  }

  .expiration {
    margin-left: 15px;
  }
</style>
